import { useEffect, useLayoutEffect, useMemo } from "react";
import { View } from "react-native";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useLocale } from "@src/packages/i18n";
import type { AccessStackParamList } from "../../types";
import { SupplementDetailContent } from "../../components/SupplementDetailSheet";
import { getFactSheetRouteBlock } from "../../components/factSheetRouteIds";
import { useSmartBack } from "../../hooks/useSmartBack";

type Props = NativeStackScreenProps<AccessStackParamList, "SupplementDetail">;

export default function SupplementDetailScreen({ route, navigation }: Props) {
  const { supplementId, returnTab } = route.params;
  const { locale } = useLocale();
  const handleBack = useSmartBack({
    returnTab,
    fallbackTab: "Access",
    fallbackScreen: "Supplements",
  });

  const item = useMemo(() => {
    void locale;
    return getFactSheetRouteBlock("supplement", supplementId);
  }, [supplementId, locale]);

  useEffect(() => {
    if (!item) {
      navigation.goBack();
    }
  }, [item, navigation]);

  useLayoutEffect(() => {
    if (item) {
      navigation.setOptions({ title: item.title });
    }
  }, [item, navigation]);

  if (!item) return null;

  return (
    <View style={{ flex: 1 }}>
      <SupplementDetailContent
        item={item}
        onClose={handleBack}
        skipExitAnimation
      />
    </View>
  );
}
